import { Fragment, ReactNode } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';

interface Props {
  actions?: ReactNode;
  children: ReactNode;
  disableGrid?: boolean;
  sx?: any;
  title: ReactNode;
}

export function DashboardContentLayout({ actions, children, disableGrid, sx, title }: Props) {
  const TopComponent = disableGrid ? Stack : Fragment;
  const topComponentProps = disableGrid
    ? {
        direction: 'row' as const,
        width: '100%',
      }
    : {};

  return (
    <Box
      data-testid="active-content"
      display={disableGrid ? 'flex' : 'grid'}
      flexDirection={disableGrid ? 'column' : undefined}
      gridTemplateColumns={disableGrid ? undefined : 'auto 1fr'}
      gridTemplateRows={disableGrid ? undefined : 'auto 1fr'}
      height="100%"
      maxHeight="100%"
      sx={sx}
      width="100%"
    >
      <TopComponent {...topComponentProps}>
        <Typography
          bgcolor="neutral.800"
          borderBottom="1px solid"
          borderColor="divider"
          paddingLeft={{ xl: 2, xs: 8 }}
          paddingRight={4}
          paddingY={2}
          variant="h5"
        >
          {title}
        </Typography>
        <Box
          bgcolor="neutral.800"
          borderBottom="1px solid"
          borderColor="divider"
          flex="1 1 auto"
          minWidth={0}
          paddingRight={2}
        >
          {actions}
        </Box>
      </TopComponent>
      {children}
    </Box>
  );
}
